import request from 'superagent';

import { handleSuccess, handleError } from '_utils/api';

const BASE_URL = process.env.BACKEND_URL ?? 'http://localhost:3000';

const api = {
    get: (endpoint, query = {}) =>
        request
            .get(`${BASE_URL}${endpoint}`)
            .withCredentials()
            .query(query)
            .then(handleSuccess)
            .catch(handleError),

    post: (endpoint, body = {}) =>
        request
            .post(`${BASE_URL}${endpoint}`)
            .withCredentials()
            .send(body)
            .then(handleSuccess)
            .catch(handleError),

    put: (endpoint, body = {}) =>
        request
            .put(`${BASE_URL}${endpoint}`)
            .withCredentials()
            .send(body)
            .then(handleSuccess)
            .catch(handleError),

    delete: (endpoint) =>
        request
            .delete(`${BASE_URL}${endpoint}`)
            .withCredentials()
            .then(handleSuccess)
            .catch(handleError),
};

export default api;